import React from "react";
import { FaPlane, FaPassport, FaUmbrella } from "react-icons/fa";
import { HiGlobeAlt, HiShieldCheck } from "react-icons/hi2";
import "../styles/Pages.css";

const TravelPage = ({ user }) => {
  const travelServices = [
    {
      id: "insurance",
      icon: <FaUmbrella />,
      title: "Travel Insurance",
      description:
        "Comprehensive coverage for international and domestic travel",
      coverage: [
        "Medical emergencies up to R5M",
        "Trip cancellation & delays",
        "Lost luggage compensation",
        "24/7 emergency assistance",
      ],
      price: "From R150 per trip",
    },
    {
      id: "forex",
      icon: <HiGlobeAlt />,
      title: "Foreign Exchange",
      description: "Competitive rates for over 50 currencies",
      coverage: [
        "Best exchange rates guaranteed",
        "Cash or travel card options",
        "Reserve online, collect in-branch",
        "No hidden fees",
      ],
      price: "Live rates available",
    },
    {
      id: "packages",
      icon: <FaPlane />,
      title: "Travel Packages",
      description: "Exclusive deals on flights, hotels, and tours",
      coverage: [
        "Discounted flight bookings",
        "Hotel packages worldwide",
        "Curated tour experiences",
        "Flexible payment plans",
      ],
      price: "Deals from R5,999",
    },
    {
      id: "visa",
      icon: <FaPassport />,
      title: "Visa Assistance",
      description: "Fast-track visa processing for popular destinations",
      coverage: [
        "Document verification",
        "Application assistance",
        "Priority processing",
        "Travel advisory services",
      ],
      price: "From R500 per visa",
    },
  ];

  return (
    <div className="page-container">
      <div className="page-header">
        <h1>Travel Services</h1>
        <p className="page-subtitle">
          Everything you need for your next adventure
        </p>
      </div>

      <div className="travel-services">
        <h3>Travel Services</h3>
        <div className="services-grid">
          {travelServices.map((service) => (
            <div key={service.id} className="travel-service-card">
              <div className="service-icon-large">{service.icon}</div>
              <h4>{service.title}</h4>
              <p className="service-description">{service.description}</p>

              <div className="service-coverage">
                <h5>What's Included</h5>
                <ul>
                  {service.coverage.map((item, idx) => (
                    <li key={idx}>
                      <HiShieldCheck className="coverage-icon" />
                      {item}
                    </li>
                  ))}
                </ul>
              </div>

              <div className="service-price">{service.price}</div>
              <button className="btn-primary">Get Started</button>
            </div>
          ))}
        </div>
      </div>

      <div className="travel-tips">
        <h3>Travel Tips & Information</h3>
        <div className="tips-grid">
          <div className="tip-card">
            <h4>Passport Requirements</h4>
            <p>
              Ensure your passport is valid for at least 6 months beyond your
              travel dates
            </p>
          </div>
          <div className="tip-card">
            <h4>Currency Exchange</h4>
            <p>
              Order your foreign currency 3-5 days before travel for best rates
            </p>
          </div>
          <div className="tip-card">
            <h4>Travel Insurance</h4>
            <p>
              Book travel insurance at the same time as your flights for maximum
              coverage
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default TravelPage;
